/**
 * Corresponds to DateRangeOption in the back end.
 */
export const DATE_RANGE_OPTIONS = {
    allTime: 0, // 0 and null are treated equivalently by server
    thirtyDays: 1,
    ninetyDays: 2,
    trailing12Months: 3
};
